// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__31Q3q","footer":"Form_footer__3iDhk"};